module.exports = __webpack_public_path__ + "static/media/logo-horizontal.174ce3e8.svg";